export default __webpack_public_path__ + "static/28-c44cf3bbae9d3a194d71b28ea09924ed.jpg";